import { Button } from '@/components/Button';
import { ContactBox } from '@/components/ContactBox';
import { DisplayComponent } from '@/components/DisplayComponent';
import { Header } from '@/components/Header';
import { RemoteImage } from '@/components/RemoteImage';
import { setPaidAmount } from '@/context/borrower';
import { EDisplays, setDisplay } from '@/context/display';
import { useAppDispatch } from '@/context/storeHooks';

const baseId = 'screen-IncomeIneligible';

export function IncomeIneligible(): JSX.Element {
    // ***** Redux State *****
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleIncomeChange(): void {
        dispatch(setPaidAmount(undefined));
        dispatch(setDisplay(EDisplays.INCOME));
    }

    return (
        <DisplayComponent baseId={baseId} data-testid={baseId}>
            <Header />
            <div className='flex-center pb-4 relative'>
                <div className='bg-primary h-40 w-40 rounded-full' />
                <RemoteImage fileName='coins.svg' className='absolute' />
            </div>
            <div className='text-center flex flex-col space-y-2'>
                <h3 className='uppercase text-xl text-primary font-bold'>
                    Minimum Income not met
                </h3>
                <p className='text-secondary text-left mx-6 py-0.5'>
                    Your current income level does not meet the minimum
                    requirement for a novated lease.
                </p>
                <p className='text-secondary text-left mx-6 py-0.5'>
                    To ensure affordability, novated leases require a minimum
                    taxable income threshold. If your salary is below this, it
                    may not be a suitable option at this time.
                </p>
                <p className='text-sm text-left mx-6 py-0.5'>
                    You may want to check with your employer for salary
                    packaging alternatives or explore other financing options.
                </p>
            </div>
            <div className='_flex space-x-2 mx-4 pt-4'>
                <Button
                    id={`${baseId}-button-reduceLoan`}
                    onClick={handleIncomeChange}
                >
                    Edit Income Details
                </Button>
            </div>
            <div className='flex-center w-full'>
                <ContactBox />
            </div>
        </DisplayComponent>
    );
}
